// routes/AdminRoute.js
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../hooks/AdminAuthProvider";

const AdminRoute = ({ children }) => {
  const { isAdminTokenValid } = useAdminAuth();

  if (!isAdminTokenValid()) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminRoute;
